/**
 * Scoreboard configuration constants
 *
 * Centralized constants for magic numbers and configuration values
 * used throughout the scoreboard feature.
 */

/**
 * Auto-scroll configuration
 */
export const AUTO_SCROLL_CONFIG = {
  /** Scroll speed in pixels per frame */
  SCROLL_SPEED_PX: 0.5,
  /** Pause duration at end of scroll in milliseconds */
  PAUSE_DURATION_MS: 3000,
  /** Initial delay before starting scroll in milliseconds */
  START_DELAY_MS: 100,
} as const;

/**
 * File upload constraints
 */
export const UPLOAD_CONSTRAINTS = {
  /** Maximum file size for logo uploads (5MB) */
  MAX_LOGO_SIZE_BYTES: 5 * 1024 * 1024,
  /** Allowed image MIME types for logo uploads */
  ALLOWED_IMAGE_TYPES: [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/svg+xml',
    'image/webp',
  ],
} as const;

/**
 * Display configuration
 */
export const DISPLAY_CONFIG = {
  /** Maximum number of leaderboard entries to display */
  MAX_LEADERBOARD_ENTRIES: 100,
  /** Default background image opacity */
  DEFAULT_BACKGROUND_OPACITY: 0.3,
} as const;
